import { ActionsCard } from 'components/Cases/Actions/ActionsCard/ActionsCard';
import useDiagnosisForm from 'components/Cases/hooks/useDiagnosisForm';
import { usePreventEditLeave } from 'hooks/usePreventEditLeave/usePreventEditLeave';
import { CaseForm, CaseListItem } from 'queries/cases/types';
import { FormProvider } from 'react-hook-form';
import CaseDetailsFooter from './Footer';
import { TabsCard } from './TabsCard';
import './details.style.scss';
import { FeedbackForm } from 'components/Cases/Feedback/FeedbackForm';
import CaseFormStep from 'components/Cases/CaseFormStep/CaseFormStep';
import { DiagnosisForm } from 'components/Cases/Diagnosis/DiagnosisForm';
import CaseHeaderDetailsCard from './CaseHeaderDetails/CaseHeaderDetails';
import CaseDetailsChips from './CaseDetailsChips';

export interface DetailsCardProps {
  selectedRow?: Partial<CaseListItem> | Partial<CaseForm>;
  navigationState?: object;
}

export const CaseDetails = ({ selectedRow, navigationState }: DetailsCardProps) => {
  const { formMethods, onSubmit, isFormDisabled, isFormLoading } = useDiagnosisForm(selectedRow);
  usePreventEditLeave(formMethods.control);
  return (
    <FormProvider {...formMethods}>
      <div className="case-details">
        <CaseHeaderDetailsCard
          selectedRow={selectedRow}
          isFormDisabled={isFormDisabled}
          navigationState={navigationState}
        />
        <div className="case-layout">
          <CaseDetailsChips isFormDisabled={isFormDisabled} selectedRow={selectedRow} />
          <div className="steps">
            <CaseFormStep
              formComponent={DiagnosisForm}
              stepName="diagnosis"
              isFormDisabled={isFormDisabled}
              onSubmit={onSubmit}
            />
            <ActionsCard isFormDisabled={isFormDisabled} onSubmit={onSubmit} />
            <CaseFormStep
              formComponent={FeedbackForm}
              stepName="feedback"
              isFormDisabled={isFormDisabled}
              onSubmit={onSubmit}
            />
            <TabsCard isFormDisabled={isFormDisabled} />
          </div>
        </div>
        <CaseDetailsFooter
          onSubmit={onSubmit}
          isFormDisabled={isFormDisabled}
          isFormLoading={isFormLoading}
        />
      </div>
    </FormProvider>
  );
};
